/* eslint-disable consistent-return */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { isMobile } from '../../../../helpers/price-helper';

const ECOREBATES_SCRIPT_URL = '//static.ecorebates.com/widgets/thd/product.js';
const getEcoRebatesScript = () => document.querySelector(`script[src="${ECOREBATES_SCRIPT_URL}"]`);
const hasEcoRebatesScript = () => typeof window !== 'undefined' && Boolean(getEcoRebatesScript());
const loadEcoRebatesScript = () => {
  const ecoRebatesScript = document.createElement('script');
  ecoRebatesScript.type = 'text/javascript';
  ecoRebatesScript.async = true;
  ecoRebatesScript.src = ECOREBATES_SCRIPT_URL;
  document.body.appendChild(ecoRebatesScript);
};

const getUiContext = () => {
  if (typeof window !== 'undefined') {
    const { href, host } = window.location;
    return href.includes(`${host}/p/`) ? 'PDP' : 'PLP';
  }
};

const triggerRebateAnalytics = () => {
  window.LIFE_CYCLE_EVENT_BUS.trigger('price.rebates_click', {});
};

export const Rebates = ({
  itemId,
  zipCode,
  channel
}) => {
  useEffect(() => {
    if (hasEcoRebatesScript()) return;
    loadEcoRebatesScript();
  }, []);

  const rebateClass = classNames('sui-underline', {
    'sui-text-sm': !isMobile(channel),
    'sui-text-xs': isMobile(channel)
  });

  return (
    <ecr-product-widget
      skus={itemId}
      zip={zipCode}
      uiContext={getUiContext()}
      rebateConsumerTypes="residential,commercial"
      data-nr-disable
    >
      <div slot="open-details" className={rebateClass} style={{ display: 'none' }}>
        <a href="#" onClick={triggerRebateAnalytics}>
          {`Save up to {totalAmount} in {altRebateConsumerType} Rebates and Promotions`}
        </a>
      </div>
      <div slot="open-details-no-amount" className={rebateClass} style={{ display: 'none' }}>
        <a href="#" onClick={triggerRebateAnalytics}>
          {`Save up to {offerCount} {altRebateConsumerType} Rebate{s} and Promotion{s}`}
        </a>
      </div>
    </ecr-product-widget>
  );
};

Rebates.propTypes = {
  itemId: PropTypes.string,
  zipCode: PropTypes.string,
  channel: PropTypes.bool
};

Rebates.defaultProps = {
  itemId: null,
  zipCode: null,
  channel: false
};
